// Русское счётное слово: 1 позиция, 2 позиции, 5 позиций. Отдельной функцией, а не
// конкатенацией по месту — форм три, и правило про 11–14 забывается первым.
export const pluralize = (count: number, one: string, few: string, many: string): string => {
    const tens = count % 100;
    if (tens >= 11 && tens <= 14) return many;

    const ones = count % 10;
    if (ones === 1) return one;
    if (ones >= 2 && ones <= 4) return few;

    return many;
};
